import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Box, Typography } from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../utils/constants';

interface WebsocketConnection {
  pk: string;
  sk: string;
  connection_id: string;
  route: string;
  state: string;
  created_at: string;
  updated_at: string;
  deployment_state: string;
  cf_stack_name: string | null;
  cf_stack_status: string | null;
  frontend_artifact_status: string;
  code_s3_bucket_name: string | null;
  code_s3_prefix: string | null;
}

export const WebsocketConnections: React.FC = () => {
  const [connections, setConnections] = useState<WebsocketConnection[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConnections = async () => {
      try {
        const response = await axios.get(`${API_URL}/websocket_connections`);
        setConnections(response.data.items);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching websocket connections:', error);
        setLoading(false);
      }
    };

    fetchConnections();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px', paddingTop: '40px', paddingBottom: '20px', borderRadius: '8px' }}>
      <Typography variant="h3" sx={{ marginBottom: '40px', color: '#333', textAlign: 'center' }}>Executions</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Connection ID</TableCell>
              <TableCell>Route</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Updated At</TableCell>
              <TableCell>Deployment State</TableCell>
              <TableCell>CloudFormation Stack Name</TableCell>
              <TableCell>CloudFormation Stack Status</TableCell>
              <TableCell>S3 Bucket Name</TableCell>
              <TableCell>S3 Prefix</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {connections.map((connection) => (
              <TableRow key={connection.pk}>
                <TableCell>{connection.connection_id}</TableCell>
                <TableCell>{connection.route}</TableCell>
                <TableCell>{connection.state}</TableCell>
                <TableCell>{connection.created_at}</TableCell>
                <TableCell>{connection.updated_at}</TableCell>
                <TableCell>{connection.deployment_state}</TableCell>
                <TableCell>{connection.cf_stack_name || 'N/A'}</TableCell>
                <TableCell>{connection.cf_stack_status || 'N/A'}</TableCell>
                <TableCell>{connection.code_s3_bucket_name || 'N/A'}</TableCell>
                <TableCell>{connection.code_s3_prefix || 'N/A'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WebsocketConnections;